export { default as DesktopCart } from './DesktopCart';
export { default as MobileCart } from './MobileCart';


// WEBPACK FOOTER //
// ./src/partials/shared/Cart/index.js